<template>
  <div>
    <v-card
      v-if="item"
      class="intent-item py-2 px-1 mb-3"
      elevation="0"
      :style="{
        border: `1px solid ${$vuetify.theme.primary}`,
        borderLeft: item.active ? `5px solid #a0e83d` : `5px solid red`
      }"
    >
      <v-layout wrap>
        <v-flex xs12 sm6>
          <v-layout>
            <div class="mr-2">
              <toggle-button
                :disabled="item.status !== 'APPROVED'"
                :value="item.active"
                :sync="true"
                :color="$vuetify.theme.success"
                :labels="{ checked: 'ON', unchecked: 'OFF' }"
                style="display: inline-block"
                @change="handleChangeActiveTemplate"
              />
            </div>
            <div>{{ item.name }}</div>
          </v-layout>
        </v-flex>
        <v-flex xs12 sm6>
          <v-layout column align-end>
            <div>
              <v-layout v-if="!isLiveChat" justify-end>
                <div class="mr-2">
                  <v-chip disabled small :color="statusColor" text-color="white">{{
                    item.status
                  }}</v-chip>
                </div>
                <div>
                  <v-btn fab outline color="primary" class="extra-small ma-1" @click="handleEdit">
                    <i class="fas fa-pencil-alt"></i>
                  </v-btn>
                  <v-btn fab outline color="primary" class="extra-small ma-1" @click="handleDelete">
                    <i class="fa fa-trash middle"></i>
                  </v-btn>
                </div>
              </v-layout>
              <template v-else>
                <v-btn color="primary" @click="handleEditAndSend"> แก้ไขก่อนส่ง </v-btn>
                <v-btn depressed color="primary" @click="handleSendTemplate">
                  <em class="fas fa-paper-plane mr-2"></em>
                  {{ $t('Send') }}
                </v-btn>
              </template>
            </div>
            <div class="mt-1">
              <span
                class="fas"
                :style="`font-size: 1.5em;margin-right: 5px; cursor: pointer; color: ${$vuetify.theme.primary}`"
                :class="{ 'fa-chevron-down': !showDetail, 'fa-chevron-up': showDetail }"
              ></span>
            </div>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import whatsappApi from '@/api/whatsapp.js'
import { mapGetters } from 'vuex'
import { ToggleButton } from 'vue-js-toggle-button'

export default {
  components: {
    ToggleButton
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    isLiveChat: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showDetail: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    statusColor() {
      let color = 'success'
      if (this.item.status === 'REJECTED') {
        color = 'error'
      } else if (this.item.status === 'PENDING') {
        color = 'warning'
      }

      return color
    }
  },
  mounted() {},
  methods: {
    async handleChangeActiveTemplate() {
      const vm = this
      try {
        vm.item.active = !vm.item.active

        vm.$store.dispatch('loading')
        const response = await whatsappApi.putUpdateActiveWhatsappTemplate({
          id: vm.item.template_id,
          data: {
            page_id: vm.selectedBot.pageid,
            active: vm.item.active
          }
        })
        vm.$store.commit('CLEAR_LOADING')

        if (response && response.status !== 200) {
          vm.item.active = !vm.item.active
        }
      } catch (error) {
        vm.item.active = !vm.item.active
        vm.$store.commit('CLEAR_LOADING')
        console.error(error)
      }
    },
    async handleDelete() {
      const vm = this
      try {
        const result = await vm.$swal.fire({
          title: vm.$t('Do you want to delete {name}?', {
            name: vm.item.name
          }),
          type: 'warning',
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true,
          showCancelButton: true
        })
        if (result.value) {
          vm.$store.dispatch('loading')
          const response = await vm.deleteTemplate()
          vm.$store.commit('CLEAR_LOADING')

          if (response && response.status === 200) {
            vm.$emit('onRefetchData')
          }
        }
      } catch (error) {
        console.error(error)
      } finally {
        vm.$store.commit('CLEAR_LOADING')
      }
    },
    async deleteTemplate() {
      try {
        const response = await whatsappApi.deleteWhatsappTemplate({
          data: {
            page_id: this.selectedBot.pageid,
            id: this.item.template_id
          }
        })

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    },
    handleEdit() {
      this.$emit('onEdit', this.item)
    },
    handleEditAndSend() {
      this.$emit('onEditAndSend', this.item)
    },
    handleSendTemplate() {
      const vm = this
      const { template_id, lang } = vm.item
      const payload = {
        page_id: vm.$store.state.livechat.pageid,
        userid: vm.$store.state.livechat.currentUser.userid,
        template_id,
        lang
      }
      vm.$emit('sendToLivechat', payload)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/whatsapp/TemplateManagement/TemplateItemCard.vue